/**
 * Per-category toggles for the built-in master data columns. The API always
 * returns every key; when sending, omitted keys are treated as enabled — except
 * show_location/edit_location, which default to false since most datasets have
 * no geographic data.
 */
export interface MasterDataColumnConfig {
  show_code: boolean;
  show_parent_key: boolean;
  show_additional_info: boolean;
  show_location: boolean;
  edit_label: boolean;
  edit_parent_key: boolean;
  edit_additional_info: boolean;
  edit_location: boolean;
}

export const DEFAULT_COLUMN_CONFIG: MasterDataColumnConfig = {
  show_code: true,
  show_parent_key: true,
  show_additional_info: true,
  show_location: false,
  edit_label: true,
  edit_parent_key: true,
  edit_additional_info: true,
  edit_location: false,
};

export interface MasterDataCategory {
  id: number;
  org_id: string;
  name: string;
  label: string;
  description?: string | null;
  label_column_name?: string | null;
  sort_order: number;
  is_default: boolean;
  column_config?: MasterDataColumnConfig | null;
  created_at: string;
}

export interface CreateMasterDataCategoryDto {
  name: string;
  label: string;
  description?: string | null;
  label_column_name?: string | null;
  sort_order?: number;
  column_config?: MasterDataColumnConfig;
}

export interface UpdateMasterDataCategoryDto {
  label: string;
  description?: string | null;
  label_column_name?: string | null;
  sort_order?: number;
  is_default?: boolean;
  column_config?: MasterDataColumnConfig;
}
